import React from "react";
import { appInsightsEnabled, reactPlugin } from "./appInsights";
import { AppInsightsContext, AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import ErrorOverlay from "./components/common/ErrorOverlay";

const ErrorFallback = () => <ErrorOverlay />;

const noopAppInsights = {
  trackTrace: () => {},
  trackEvent: () => {},
  trackException: () => {},
  trackMetric: () => {},
  trackPageView: () => {},
  trackDependencyData: () => {},
};

const AppInsightsContextProvider = ({ children }) => {
  if (!appInsightsEnabled) {
    return (
      <AppInsightsContext.Provider value={noopAppInsights}>
        {children}
      </AppInsightsContext.Provider>
    );
  }

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <AppInsightsErrorBoundary
        onError={ErrorFallback}
        appInsights={reactPlugin}
      >
        {children}
      </AppInsightsErrorBoundary>
    </AppInsightsContext.Provider>
  );
};

export { AppInsightsContextProvider };
